export default __webpack_public_path__ + "static/media/mille_pas.5c4bee5f.jpg";